import { FC, useCallback } from 'react'

import { Center, Flex, Square, useDisclosure } from '@chakra-ui/react'
import { HelpCircleIcon } from '@editor/assets/icons'
import TutorialVideoModal from '@editor/components/TutorialVideoModal'
import { EDITOR_TOOL_BUTTON_SIZE } from '@editor/config/constants'
import { RootState } from '@editor/store/app'
import { Tooltip } from '@infraloop/common'
import mixpanel from 'mixpanel-browser'
import { useSelector } from 'react-redux'

const HelpButton: FC = () => {
  const useDisclosureProps = useDisclosure()
  const { onOpen } = useDisclosureProps

  // store
  const videoConfig = useSelector((root: RootState) => root.videos.selectedVideoConfig)

  // tracking
  const openModal = useCallback(() => {
    if (videoConfig) {
      mixpanel.track('Show Help Modal', {
        'Selected Tool': videoConfig.toolType,
        'Video URL': videoConfig.videoUrl,
        'External URL': videoConfig.helpCenterUrl,
        'Triggered By': 'Help Button',
        'Help Config Version': videoConfig.version,
      })
    }

    // Open modal
    onOpen()
  }, [onOpen, videoConfig])

  return (
    <>
      {videoConfig && <TutorialVideoModal useDisclosureProps={useDisclosureProps} {...videoConfig} />}
      <Square
        position="relative"
        backgroundColor="gray2.800"
        color="white"
        fontSize="xl"
        size={EDITOR_TOOL_BUTTON_SIZE}
        borderRadius="md"
        onClick={openModal}
      >
        <Tooltip
          showArrow
          positioning={{ placement: 'right' }}
          label="ユーザーマニュアル" /* TODO: style migration needed - p=2 */ /* TODO: style migration needed - fontSize=xs */ /* TODO: style migration needed - fontWeight=normal */
        >
          <Flex>
            <Center width="100%" height="100%">
              <HelpCircleIcon size="60%" />
            </Center>
          </Flex>
        </Tooltip>
      </Square>
    </>
  )
}

export default HelpButton
